<template>
  <base-button
    v-if="file"
    size="sm"
    :type="file.completed_at ? 'success' : 'primary'"
    :outline="!!file.completed_at"
    :disabled="saving || locked"
    @click="toggle"
  >
    <i :class="icon" class="mr-1"></i>
    {{ label }}
  </base-button>
</template>

<script>
export default {
  name: "training-seen-button",

  props: {
    file: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      saving: false,
    };
  },

  computed: {
    // A video to watch to the end is ticked by the player, at the end.
    locked() {
      return this.file.must_watch && !this.file.completed_at;
    },
    icon() {
      if (this.file.completed_at) {
        return "fa fa-check";
      }
      return this.locked ? "fa fa-lock" : "far fa-square";
    },
    label() {
      if (this.file.completed_at) {
        return this.$t("TRAININGS.SEEN_ON", {
          date: this.$timeZoneDateFormat(this.file.completed_at, "LL"),
        });
      }
      return this.locked
        ? this.$t("TRAININGS.WATCH_TO_THE_END")
        : this.$t("TRAININGS.MARK_AS_SEEN");
    },
  },

  methods: {
    async toggle() {
      this.saving = true;
      try {
        await this.$store.dispatch("trainings/setCompleted", {
          fileId: this.file.id,
          completed: !this.file.completed_at,
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
      this.saving = false;
    },
  },
};
</script>
